import { z } from 'zod';
import { assertExportBudget, type ExportTimingInput } from './export-range.js';

export const ExportRangeSchema = z.object({ inFrame: z.int().min(0), outFrame: z.int().min(0),
  durationSeconds: z.int().min(5).max(240).optional() }).strict();

export function validExportTiming(value: ExportTimingInput): boolean {
  try { assertExportBudget(value); return true; } catch { return false; }
}

export const EXPORT_RANGE_ERROR = 'IN and OUT must be ordered frames within the film and select at least five seconds.';
export function readStoredExportRange(raw: string | null | undefined) {
  return raw == null ? undefined : ExportRangeSchema.parse(JSON.parse(raw));
}
